import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useGetSailTag } from "./hooks/useGetSailTag";
import {
    BrowserRouter,
    Route,
    Routes,
    Navigate,
    useNavigate,
} from "react-router";
const Home: React.FC = () => {
    const [guid, setGuid] = React.useState<string>("");
    const { data: qrCodeBlob } = useGetSailTag(guid, 50);
    let navigate = useNavigate();
    React.useEffect(() => {
        if (!qrCodeBlob || !(qrCodeBlob instanceof Blob) || !guid) return;

        const url = URL.createObjectURL(qrCodeBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `qrcode-${guid}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        setGuid("");
    }, [qrCodeBlob]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                justifyContent: "space-between",
            }}
        >
            <Stack
                spacing={3}
                sx={{
                    margin: 2,
                    alignItems: "center",
                }}
            >
                <Header Title="North Sails SailTag" />
                <Typography variant="body1">
                    Scan the QR Code on your sail for more information
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        navigate("/servicelofts");
                    }}
                >
                    Find Your Nearest Service Loft
                </Button>
            </Stack>
            <Footer />
        </div>
    );
};

export default Home;
